/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  GetPresentationService,
  IGetPresentationMethods,
  GetCostumeTypeService,
  IGetCostumeTypeMethods,
  CreateBoxService,
  ICreateBoxTypeMethods,
  ICreatePayFACMethods,
  CreatePayFACService,
  GetPreBookedAmtService,
  IGetPreBookedAmtMethods,
  IValidateDiscountMethods,
  ValidateDiscountService,
  IGetMyDiscountMethods,
  GetMyDiscountService,
  GetCitiesService,
  IGetCitiesMethods,
  IMyProfileCardMethods,
  MyProfileCardService,
  IUpdateBoxMethods,
  UpdateBoxService,
  AddToCartService,
  IAddToCartMethods,
  IgetAllCartsMethods,
  getAllCartsService,
  IdeleteCartMethods,
  deleteCartService,
  ICreateMultiBoxMethods,
  CreateMultiBoxService,
  ICreateMultiBoxCampMethods,
  CreateMultiBoxCampService,
  ICostumePayNowMethods,
  CostumePayNowService,
  ICostumeCreateTransactionMethods,
  CostumeCreateTransactionService,
  ICostumeComplete3dsMethods,
  CostumeComplete3dsService,
} from "./components";

export type CostumePageAgent = IStaticPageContentMethods &
  IGetPresentationMethods &
  ICreatePayFACMethods &
  IGetCostumeTypeMethods &
  IGetPreBookedAmtMethods &
  ICreateBoxTypeMethods &
  IGetMyDiscountMethods &
  IMyProfileCardMethods &
  IUpdateBoxMethods &
  IAddToCartMethods &
  IGetCitiesMethods &
  IgetAllCartsMethods &
  IdeleteCartMethods &
  ICreateMultiBoxCampMethods &
  ICreateMultiBoxMethods &
  IValidateDiscountMethods &
  ICostumePayNowMethods &
  ICostumeCreateTransactionMethods &
  ICostumeComplete3dsMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new GetPresentationService(),
    new GetCostumeTypeService(),
    new GetCitiesService(),
    new UpdateBoxService(),
    new MyProfileCardService(),
    new CreateBoxService(),
    new CreatePayFACService(),
    new AddToCartService(),
    new CreateMultiBoxService(),
    new GetPreBookedAmtService(),
    new ValidateDiscountService(),
    new GetMyDiscountService(),
    new getAllCartsService(),
    new deleteCartService(),
    new CreateMultiBoxCampService(),
    new CostumePayNowService(),
    new CostumeCreateTransactionService(),
    new CostumeComplete3dsService(),
  ];
};

export const getAgent = () => {
  return createAgent<CostumePageAgent>({
    plugins: getPlugins(),
  });
};
